'use client';
import { GoogleTagManager } from '@next/third-parties/google';
import { useEffect } from 'react';
import { ccStorage } from '../../utils/storages/local/CookieStorageClient';
import GoogleTag from './GoogleTag';

interface GoogleTrackingProps {
  gaId?: string;
  googleAdsId?: string;
  gtmId?: string;
  consent?: boolean;
  needConsent?: boolean;
}

const GoogleTracking = ({
  gaId,
  googleAdsId,
  gtmId,
  consent,
  needConsent,
}: GoogleTrackingProps) => {
  useEffect(() => {
    if (!needConsent) return;
    let ok = consent;
    if (typeof consent === 'undefined') {
      ok = ccStorage.get('cookie-consent');
    }
    const status = ok == true ? 'granted' : 'denied';

    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: status,
        ad_storage: status,
        ad_user_data: status,
        ad_personalization: status,
      });
    }
  }, [consent, needConsent]);

  const googleTagIds = [gaId, googleAdsId].filter((id): id is string => !!id);

  return (
    <>
      {googleTagIds.length > 0 && (
        <GoogleTag ids={googleTagIds} needConsent={needConsent} />
      )}
      {gtmId && <GoogleTagManager gtmId={gtmId} />}
    </>
  );
};

export default GoogleTracking;
